import React from 'react'
import { withTheme } from '@emotion/react'
import PropTypes from 'prop-types'
import withMenuPositioning from 'shared/ui/Dropdown/withMenuPositioning'
import IconWithTooltip from '../../shared/IconWithTooltip'

class ToolbarIcon extends React.Component {
  componentWillReceiveProps(newProps, oldProps) {
    // if the HOC recomputes our coords, hit the provided callback so we can
    // re-render the toolbar inside the Editor
    if (
      newProps.left !== oldProps.left ||
      newProps.bottom !== oldProps.bottom
    ) {
      const { onResize, bottom, left } = newProps
      if (onResize) return onResize(bottom, left)
    }
    return false
  }

  handleClick = e => {
    const { onClick, bottom, left } = this.props
    if (!onClick) return false // typescript where are you?
    return onClick(bottom, left, e)
  }

  render() {
    const { showToolbar, theme } = this.props

    return (
      <IconWithTooltip
        active={showToolbar}
        color={showToolbar ? theme.color.primary.brand : undefined}
        name="text-format"
        onClick={this.handleClick}
        tooltip={`${!showToolbar ? 'Show' : 'Hide'} font toolbar`}
        tooltipPosition={!showToolbar ? 'top' : 'right'}
      />
    )
  }
}

ToolbarIcon.propTypes = {
  onClick: PropTypes.func.isRequired,
  onResize: PropTypes.func, // eslint-disable-line react/no-unused-prop-types
  showToolbar: PropTypes.bool,
}

ToolbarIcon.defaultProps = {
  showToolbar: false,
  onResize: null,
}

export default withTheme(withMenuPositioning(ToolbarIcon))
